import { EmployeesOverview } from '../translations-types';

const translations: EmployeesOverview = {
  addEmployee: 'Add employee',
};

export default translations;
